<script>
import CMSSinglePage from "@/views/components/cms/CMSSinglePage.vue";

export default {
  name: "Aktuelles",
  components: {CMSSinglePage},
}
</script>

<template>
 <CMSSinglePage list-element="AktuellesList"></CMSSinglePage>
</template>

<style scoped>

</style>
